<template> <!-- OK -->
    <div>
        <NavBar/>
        <div class="pagina-inicial-container">
            <div class="stage-selector">
              <select v-model="selectedStageId" @change="loadGroups">
                <option v-for="stage in stages" :key="stage.id" :value="stage.id">
                  {{ stage.name }}
                </option>
              </select>
              <span v-if="selectedStage">
                {{ selectedStage.startDateFormatted }} - {{ selectedStage.endDateFormatted }}
              </span>
            </div>
            <GroupTable
              :groups="groups"
              :selectedGroup="selectedGroup"
              :groupPlayers="groupPlayers"
              @select-group="selectGroup"
            />
        </div>
    </div>
  </template>
  
  <script>
  import NavBar from '../components/NavBar.vue';
  import GroupTable from '../components/GroupTable.vue';
  import groupService from '../services/groupService';
  import stageService from '../services/stageService';
  import userService from '../services/userService';
  
  export default {
    name: 'PaginaInicial',
    components: {
      NavBar,
      GroupTable,
    },
    data() {
      return {
        stages: [],
        groups: [],
        selectedStageId: null,
        selectedGroup: null,
        selectedStage: null,
        groupPlayers: [],
      };
    },
    created() {
      this.loadStages();
    },
    methods: {
      async loadStages() {
        try {
          const response = await stageService.getAllStages();
          this.stages = response.data.map(stage => ({
            ...stage,
            startDateFormatted: new Date(stage.startDate).toLocaleDateString('pt-BR', {timeZone: 'UTC'}),
            endDateFormatted: new Date(stage.endDate).toLocaleDateString('pt-BR', {timeZone: 'UTC'}),
          }));
          if (this.stages.length > 0) {
            this.selectedStageId = this.stages[this.stages.length - 1].id;
            this.selectedStage = this.stages[this.stages.length - 1];
            await this.loadUserGroup();
          }
        } catch (error) {
          console.error('Erro ao buscar etapas:', error);
        }
      },
      async loadGroups() {
        if (!this.selectedStageId) return;

        try {
          const response = await groupService.getGroupsByStage(this.selectedStageId);
          this.groups = response.data || [];

          if (this.groups.length === 0) {
            this.selectedGroup = null;
            this.groupPlayers = [];
            return;
          }

          const stillExistsInNewStage = this.groups.some(g => g.id === this.selectedGroup?.id);

          if (!stillExistsInNewStage) {
            this.selectedGroup = this.groups[0];
          }

          await this.loadPlayersInGroup();

        } catch (error) {
          console.error('Erro ao buscar grupos:', error);
        }
      },
      async loadPlayersInGroup() {
        if (this.selectedGroup && this.selectedStageId) {
          try {

            const isCurrentStage = this.stages && this.stages.length > 0 && this.stages[this.stages.length - 1].id === this.selectedStageId;

            if(isCurrentStage){
              const response = await groupService.getPlayersByGroup(this.selectedGroup.id);
              this.groupPlayers = response.data;
            } else{
              const response = await groupService.getPlayerHistoryByStage(this.selectedStageId, this.selectedGroup.id);
              this.groupPlayers = response.data;
            }
          } catch (error) {
            console.error('Erro ao buscar jogadores do grupo:', error);
          }
        }
      },
      async loadUserGroup(){
        try{
          const response = await userService.getUserGroup();
          this.selectedGroup = response.data.group;
          await this.loadGroups();
        } catch(error){
          console.error('Erro ao buscar grupo do usuário:', error);
          await this.loadGroups();
        }
      },
      selectGroup(groupId) {
        this.selectedGroup = this.groups.find((group) => group.id === groupId);
        this.loadPlayersInGroup();
      },
    },
    watch: {
      selectedStageId(newVal){
        this.selectedStage = this.stages.find(stage => stage.id === newVal);
      }
    }
  };
  </script>
  
  <style scoped>
  .pagina-inicial-container {
    background-color: #003366;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .stage-selector {
    display: flex;
    align-items: center;
    gap: 1rem;
    text-align: center;
    margin: 2rem 0;
  }
  
  .stage-selector select {
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
  }

  .stage-selector span{
    font-size: 1rem;
    color: white;
  }

  </style>
  